import { Navigate, useParams, useLocation } from "react-router-dom";

interface LegacyRedirectProps {
  to: string;
}

export function LegacyRedirect({ to }: LegacyRedirectProps) {
  const params = useParams();
  const location = useLocation();
  
  // Replace route params in the target path
  let targetPath = to;
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      targetPath = targetPath.replace(`:${key}`, value);
    }
  });
  
  // Preserve query string and hash
  const fullPath = targetPath + location.search + location.hash;
  
  return <Navigate to={fullPath} replace />;
}
